<template>
  <div>
    <!-- Sección de Filtros -->
    <div class="container-fluid p-4">
    <div class="card mb-4 shadow-sm" v-if="mostrarElemento || prestador">
      <div class="card-body" style="background-color: #E7F3FF;">
        <h2 class="h5 mb-0">Filtros de Búsqueda</h2>
        <br>
        <div class="row g-3">
          <div class="col-md-3 col-sm-6">
            <label for="cargaSeleccionada" class="form-label fw-bold">Periodo</label>
            <select
              id="cargaSeleccionada"
              name="cargaSeleccionada"
              v-model="cargaSeleccionada"
              class="form-select form-select-sm"
              @change="handleSelection"
            >
              <option value="" disabled>Seleccione...</option>
              <option
                v-for="carga in cargas"
                :key="carga.idCarga"
                :value="carga.idCarga"
              >
                {{ getFormattedDate(carga.fechaDesde) }} - {{ getFormattedDate(carga.fechaHasta) }} -
                {{ carga.tipoCarga === 'M' ? 'Mensual' : carga.tipoCarga === 'S' ? 'Semanal' : carga.tipoCarga === 'A' ? 'Autorización' : carga.tipoCarga }}
              </option>
            </select>
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="fechaAtencion" class="form-label fw-bold">Fecha de Atención</label>
            <input
              type="date"
              id="fechaAtencion"
              v-model="fechaAtencion"
              class="form-control form-control-sm"
              @change="getDataFecha(1)"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="nombreMedico" class="form-label fw-bold">Nombre del Médico</label>
            <input
              type="text"
              id="nombreMedico"
              v-model="nombreMedico"
              placeholder="Ej. Dr. García"
              class="form-control form-control-sm"
              @keyup.enter="getDataNombreMedico(1)"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="especialidadSeleccionada" class="form-label fw-bold">Especialidad</label>
            <select
              id="especialidadSeleccionada"
              v-model="especialidadSeleccionada"
              class="form-select form-select-sm"
              @change="getDataEspecialidad(1)"
            >
              <option value="">Seleccione...</option>
              <option
                v-for="especialidad in especialidades"
                :key="especialidad.idEspecialidad"
                :value="especialidad.idEspecialidad"
              >
                {{ especialidad.nombre }}
              </option>
            </select>
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="numeroBusqueda" class="form-label fw-bold">Número</label>
            <input
              type="text"
              id="numeroBusqueda"
              name="numeroBusqueda"
              v-model="numeroBusqueda"
              class="form-control form-control-sm"
              @keyup.enter="getDataNumero(1)"
              style="text-transform: uppercase"
              required
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="cedulaBusqueda" class="form-label fw-bold">Cédula</label>
            <input
              type="text"
              id="cedulaBusqueda"
              name="cedulaBusqueda"
              v-model="cedulaBusqueda"
              class="form-control form-control-sm"
              @keyup.enter="getDataCedula(1)"
              style="text-transform: uppercase"
              required
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="nombreBusqueda" class="form-label fw-bold">Nombre</label>
            <input
              type="text"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              class="form-control form-control-sm"
              @keyup.enter="getDataNombre(1)"
              style="text-transform: uppercase"
              required
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <label for="nivelBusqueda" class="form-label fw-bold">Nivel</label>
<select
  id="nivelBusqueda"
  name="nivelBusqueda"
  v-model="nivelBusqueda"
  class="form-control form-control-sm"
  @change="getDataNivel(1)"
  required
>
  <option value="">Seleccione nivel</option>
  <option value="1">Nivel 1</option>
  <option value="2">Nivel 2</option>
</select>
          </div>
          <div class="col-md-3 col-sm-6" v-if="estadoAM">
            <label for="estadoAMBusqueda" class="form-label fw-bold">Estado AM</label>
            <select
              id="estadoAMBusqueda"
              name="estadoAMBusqueda"
              v-model="estadoAMBusqueda"
              class="form-select form-select-sm"
              @change="getDataEstadoAM(1)"
              required
            >
              <option value="">Seleccione...</option>
              <option value="PENDIENTE">PENDIENTE</option>
              <option value="REVISADA">REVISADA</option>
              <option value="FINALIZADA">FINALIZADA</option>
            </select>
          </div>
          <div class="col-md-3 col-sm-6" v-if="estadoGD">
            <label for="estadoGDBusqueda" class="form-label fw-bold">Estado GD</label>
            <select
              id="estadoGDBusqueda"
              name="estadoGDBusqueda"
              v-model="estadoGDBusqueda"
              class="form-select form-select-sm"
              @change="getDataEstadoGD(1)"
              required
            >
              <option value="">Seleccione...</option>
              <option value="PENDIENTE">PENDIENTE</option>
              <option value="REVISADA">REVISADA</option>
              <option value="FINALIZADA">FINALIZADA</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-4 gap-2">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click.prevent="getDataPaginaTodos(1)"
            title="Todos los registros"
          >
            <i class="bi bi-search me-1"></i> Buscar
          </button>
          <button
            type="button"
            @click="exportarCSV"
            class="btn btn-success btn-sm"
          >
            <i class="bi bi-file-earmark-arrow-down me-1"></i> Exportar a CSV
          </button>
          <button
            type="button"
            @click="enviar"
            class="btn btn-success btn-sm"
          >
            <i class="bi bi-file-earmark-arrow-down me-1"></i> Enviar
          </button>
        </div>
      </div>
    </div>
    </div>
	

    <!-- Tabla de Atenciones Médicas -->
    <div class="card shadow-sm" v-if="planillas.length > 0">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead class="table-primary">
              <tr>
                <th scope="col">Número</th>
                <th scope="col">F. atención</th>
                <th scope="col">Cédula</th>
                <th scope="col">Nombre</th>
                <th scope="col">C.I. médico</th>
                <th scope="col" v-if="estadoAM">Diag1</th>
                <th scope="col" v-if="estadoAM">Estado AM</th>
                <th scope="col" v-if="estadoGD">Estado GD</th>
                <th scope="col">Ver Archivos</th>
                <th scope="col" class="text-center">
                  Primer Nivel
                  <button
                    class="btn btn-outline-primary btn-sm ms-2"
                    @click="toggleAllNiveles(1)"
                    title="Marcar todos"
                  >
                    <span class="material-symbols-outlined">select_check_box</span>
                  </button>
                </th>
                <th scope="col" class="text-center">
                  Segundo Nivel
                  <button
                    class="btn btn-outline-primary btn-sm ms-2"
                    @click="toggleAllNiveles(2)"
                    title="Marcar todos"
                  >
                    <span class="material-symbols-outlined">select_check_box</span>
                  </button>
                </th>
                <th scope="col" v-if="mostrarElemento">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="planilla in datosPaginados"
                :key="planilla.idPlanilla"
                @dblclick="handleRowClick($event, planilla.idPlanilla)"
                title="Doble clic para ver detalles ..."
              >
                <td>{{ planilla.numero }}</td>
                <td>{{ getFormattedDate(planilla.fechaDesde) }}</td>
                <td>{{ planilla.cedula }}</td>
                <td>{{ planilla.nombre }}</td>
                <td>{{ planilla.cedulaMedico }}</td>
                <td v-if="estadoAM">{{ planilla.diag1 }}</td>
                <td v-if="estadoAM">{{ planilla.estadoAud }}</td>
                <td v-if="estadoGD">{{ planilla.estadoDoc }}</td>
                <td class="text-center">
                  <button
                    class="btn btn-outline-primary btn-sm"
                    @click="abrirModalEditar(planilla.idPlanilla)"
                  >
                    <i class="bi bi-eye"></i> Ver
                  </button>
                </td>
                <td class="text-center">
<span
  class="material-symbols-outlined text-dark"
  @click="updateNivel(planilla.idPlanilla, 1)"
  style="cursor: pointer; font-size: 24px;"
>
  {{ planilla.nivel === 1 ? 'select_check_box' : 'crop_square' }}
</span>
                </td>
                <td class="text-center">
<span
  class="material-symbols-outlined text-dark"
  @click="updateNivel(planilla.idPlanilla, 2)"
  style="cursor: pointer; font-size: 24px;"
>
  {{ planilla.nivel === 2 ? 'select_check_box' : 'crop_square' }}
</span>
                </td>
                <td v-if="mostrarElemento">
                  <select
                    class="form-select form-select-sm"
                    @change="handleAction($event, planilla.idPlanilla)"
                    :disabled="p_tramite.estadoTramite === 'FINALIZADO'"
                  >
                    <option disabled selected>Seleccione...</option>
                    <option value="resumen">Resumen</option>
                    <option v-if="estadoGD" value="detalles">Detalles</option>
                    <option v-if="idPerfil == 16" value="borrar">Borrar</option>
                  </select>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td :colspan="calculateColspan" class="text-end fw-bold">
                  Total de atenciones: {{ planillas.length }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <nav aria-label="Page navigation" v-if="planillas.length > 0" class="mt-4">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: paginaActual === 1 }">
          <a class="page-link" href="#" @click.prevent="irPrimeraPagina">Primera</a>
        </li>
        <li class="page-item" :class="{ disabled: paginaActual === 1 }">
          <a class="page-link" href="#" @click.prevent="getPreviousPage">Anterior</a>
        </li>
        <li class="page-item active">
          <a class="page-link" href="#">{{ paginaActual }}</a>
        </li>
        <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
          <a class="page-link" href="#" @click.prevent="getNextPage">Siguiente</a>
        </li>
        <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
          <a class="page-link" href="#" @click.prevent="irUltimaPagina">Última</a>
        </li>
      </ul>
    </nav>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="modalRef"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="bi bi-person-plus-fill me-2"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <!-- NAV TABS -->
          <ul class="nav nav-tabs px-3 pt-2" id="tabsPlanilla" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="tab-uno"
                data-bs-toggle="tab"
                data-bs-target="#contenido-uno"
                type="button"
                role="tab"
                aria-controls="contenido-uno"
                aria-selected="true"
              >
                Información
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="tab-dos"
                data-bs-toggle="tab"
                data-bs-target="#contenido-dos"
                type="button"
                role="tab"
                aria-controls="contenido-dos"
                aria-selected="false"
              >
                Archivos
              </button>
            </li>
          </ul>
          <!-- CONTENIDOS DE TABS -->
          <div class="tab-content p-3">
            <!-- TAB 1 -->
            <div class="tab-pane fade show active" id="contenido-uno" role="tabpanel" aria-labelledby="tab-uno">
              <form class="border rounded p-3 shadow-sm">
                <!-- Información general -->
                <h5 class="mb-3 text-primary">Información General</h5>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Trámite</th>
                      <th>Número</th>
                      <th>Planilla</th>
                      <th>Estado AM</th>
                    </tr>
                    <tr>
                      <td>{{ datoPlanilla.idTramite || 'N/A' }}</td>
                      <td>{{ datoPlanilla.numero || 'N/A' }}</td>
                      <td>{{ datoPlanilla.idPlanilla || 'N/A' }}</td>
                      <td>{{ datoPlanilla.estadoAud || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Datos personales -->
                <h5 class="mt-4 mb-3 text-primary">Datos Personales</h5>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Cédula</th>
                      <th>Nombre</th>
                      <th>Nombre del Médico</th>
                    </tr>
                    <tr>
                      <td>{{ datoPlanilla.cedula || 'N/A' }}</td>
                      <td>{{ datoPlanilla.nombre || 'N/A' }}</td>
                      <td>{{ datoPlanilla.nombreMedico || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Diagnósticos -->
                <h5 class="mt-4 mb-3 text-primary">Diagnósticos</h5>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th v-for="i in 5" :key="i">Diag0{{ i }}</th>
                    </tr>
                    <tr>
                      <td v-for="i in 5" :key="i">
                        {{ datoPlanilla[`diag0${i}`] || 'N/A' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- Fechas y Horas -->
                <h5 class="mt-4 mb-3 text-primary">Periodo de Atención</h5>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Fecha Desde</th>
                      <th>Fecha Hasta</th>
                      <th>Hora Desde</th>
                      <th>Hora Hasta</th>
                    </tr>
                    <tr>
                      <td>{{ getFormattedDate(datoPlanilla.fechaDesde) || 'N/A' }}</td>
                      <td>{{ getFormattedDate(datoPlanilla.fechaHasta) || 'N/A' }}</td>
                      <td>{{ datoPlanilla.horaDesde || 'N/A' }}</td>
                      <td>{{ datoPlanilla.horaHasta || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </table>
              </form>
              <!-- Pie del modal para Tab 1 -->
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="abrirPlanillaPDF(datoPlanilla.idPlanilla)"
                  v-if="idPerfil === 15 && datoPlanilla.idPlanilla"
                  title="Imprimir"
                >
                  <i class="bi bi-printer-fill me-1"></i> Imprimir
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
              </div>
            </div>
            <!-- TAB 2 -->
            <div class="tab-pane fade" id="contenido-dos" role="tabpanel" aria-labelledby="tab-dos">
              <ArchivoPlaDatos
                :p_idTramite="Number(datoPlanilla.idTramite)"
                :p_idPlanilla="Number(datoPlanilla.idPlanilla)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';
import { Modal } from 'bootstrap';
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import ArchivoPlaDatos from "../forms/ArchivoPlaDatos.vue";
import Swal from 'sweetalert2';

export default {
  props: {
    p_tramite: {
      type: Object,
      required: true,
    },
  },
  components: {
    ArchivoPlaDatos,
  },
  data() {
    return {
      planillas: [],
      datoPlanilla: {},
      numeroBusqueda: "",
      cedulaBusqueda: "",
      nombreBusqueda: "",
      estadoAMBusqueda: "",
      estadoGDBusqueda: "",
      fechaAtencion: "",
      nombreMedico: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tramites: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
      idPerfil: 0,
      idUsuario: 0,
      semanas: [],
      especialidades: [],
      especialidadSeleccionada: "",
      pendientesDocumental: 0,
      tramiteLocal: { ...this.p_tramite },
      cargas: [],
      cargaSeleccionada: null,
      nivelBusqueda: "",
      modalInstance: null,
    };
  },
  computed: {
    mostrarElemento() {
      return Number(this.idPerfil) >= 16 && Number(this.idPerfil) <= 20;
    },
    prestador() {
      return this.idPerfil == 15;
    },
    estadoAM() {
      return (
        (this.idPerfil == 16 || this.idPerfil == 17 || this.idPerfil == 18) &&
        (this.p_tramite.estadoTramite === "RECIBIDO" ||
          this.p_tramite.estadoTramite === "EN PROCESO")
      );
    },
    estadoGD() {
      return (
        (this.idPerfil == 16 || this.idPerfil == 19 || this.idPerfil == 20) &&
        (this.p_tramite.estadoTramite === "RECIBIDO" ||
          this.p_tramite.estadoTramite === "EN PROCESO")
      );
    },
    gestionDocumental() {
      return (
        this.idPerfil == 20 && this.p_tramite.estadoTramite === "EN PROCESO"
      );
    },
    totalPaginas() {
      return Math.ceil(this.planillas.length / this.elementosPorPagina);
    },
    calculateColspan() {
      let colspan = 9; // Base columns: Número, F. atención, Cédula, Nombre, C.I. médico, Ver Archivos, Primer Nivel, Segundo Nivel
      if (this.estadoAM) colspan += 2; // Add Diag1, Estado AM
      if (this.estadoGD) colspan += 1; // Add Estado GD
      if (this.mostrarElemento) colspan += 1; // Add Opciones
      return colspan;
    },
  },
  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil") || 0;
    this.idUsuario = window.sessionStorage.getItem("idUsuario") || 0;
    this.getDataPaginaTodos(this.paginaActual);
    this.getEspecialidades();
    this.fetchCargas();
    this.cargarSemanasDelMes();
    this.initializeModal();
  },
  beforeUnmount() {
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
  },
  methods: {
    initializeModal() {
      this.$nextTick(() => {
        const modalElement = this.$refs.modalRef;
        if (modalElement) {
          this.modalInstance = new Modal(modalElement);
        }
      });
    },
    handleRowClick(event, idPlanilla) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION" ||
        event.target.tagName === "BUTTON"
      ) {
        return;
      }
      if (this.idPerfil == 15) {
        this.abrirModalEditar(idPlanilla);
      }
      if ([17, 18, 19, 20].includes(Number(this.idPerfil))) {
        this.abrirEditar(idPlanilla);
      }
    },
    handleAction(event, idPlanilla) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idPlanilla);
      } else if (action === "detalles") {
        this.abrirEditar(idPlanilla);
      } else if (action === "borrar") {
        this.deletePlanilla(idPlanilla);
      }
      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) {
      return date ? dateFormat.getFormattedDate(date) : "";
    },
    async fetchData(url, paginar = false, noPagina = 1) {
      try {
        const response = await api.get(url);
        let data = response.data;
        if (paginar) {
          this.setPaginacion(data, noPagina);
        } else {
          this.planillas = data;
          this.datosPaginados = data.length > 0 ? data : [];
        }
      } catch (error) {
        console.error("Error al recuperar los datos:", error);
        this.datosPaginados = [];
        this.planillas = [];
        this.$emit('error', 'No se pudieron cargar los datos. Por favor, intenta de nuevo.');
      }
    },
    setPaginacion(planillas, noPagina) {
      this.planillas = planillas;
      this.paginaActual = noPagina;
      let ini = (noPagina - 1) * this.elementosPorPagina;
      let fin = noPagina * this.elementosPorPagina;
      this.datosPaginados = this.planillas.slice(ini, fin);
    },
    resetFilters(excepto) {
      const filtros = [
        "cargaSeleccionada",
        "especialidadSeleccionada",
        "numeroBusqueda",
        "cedulaBusqueda",
        "nombreBusqueda",
        "estadoAMBusqueda",
        "estadoGDBusqueda",
        "nivelBusqueda",
        "fechaAtencion",
        "nombreMedico",
      ];
      filtros.forEach((filtro) => {
        if (filtro !== excepto) {
          this[filtro] = null;
        }
      });
    },
    getDataEspecialidad(noPagina = 1) {
      this.resetFilters("especialidadSeleccionada");
      let url = `/vwplanillas/tramite-especialidad/${this.p_tramite.idTramite}/${this.especialidadSeleccionada}`;
      this.fetchData(url, true, noPagina);
    },
    getDataNumero(noPagina = 1) {
      if (this.numeroBusqueda) {
        this.resetFilters("numeroBusqueda");
        let url = `/vwplanillas/numero/${this.p_tramite.idTramite}/${this.numeroBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataCedula(noPagina = 1) {
      if (this.cedulaBusqueda) {
        this.resetFilters("cedulaBusqueda");
        let url = `/vwplanillas/cedula/${this.p_tramite.idTramite}/${this.cedulaBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataNombre(noPagina = 1) {
      if (this.nombreBusqueda) {
        this.resetFilters("nombreBusqueda");
        let url = `/vwplanillas/nombre/${this.p_tramite.idTramite}/${this.nombreBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataNivel(noPagina = 1) {
      if (this.nivelBusqueda) {
        this.resetFilters("nivelBusqueda");
        let url = `/vwplanillas/idtramite-idcarga-nivel/${this.p_tramite.idTramite}/${this.cargaSeleccionada}/${this.nivelBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataEstadoAM(noPagina = 1) {
      if (this.estadoAMBusqueda) {
        this.resetFilters("estadoAMBusqueda");
        let url = `/vwplanillas/estadoaud/${this.p_tramite.idTramite}/${this.estadoAMBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataEstadoGD(noPagina = 1) {
      if (this.estadoGDBusqueda) {
        this.resetFilters("estadoGDBusqueda");
        let url = `/vwplanillas/estadodoc/${this.p_tramite.idTramite}/${this.estadoGDBusqueda}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataFecha(noPagina = 1) {
      if (this.fechaAtencion) {
        this.resetFilters("fechaAtencion");
        let url = `/vwplanillas/fecha/${this.p_tramite.idTramite}/${this.fechaAtencion}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataNombreMedico(noPagina = 1) {
      if (this.nombreMedico) {
        this.resetFilters("nombreMedico");
        let url = `/vwplanillas/nombre-medico/${this.p_tramite.idTramite}/${this.nombreMedico}`;
        this.fetchData(url, true, noPagina);
      }
    },
    getDataCarga(noPagina = 1) {
      if (this.cargaSeleccionada) {
        this.resetFilters("cargaSeleccionada");
        let url = `/vwplanillas/idtramite-idcarga-order-nombre/${this.p_tramite.idTramite}/${this.cargaSeleccionada}`;
        this.fetchData(url, true, noPagina);
      } else {
        this.getDataPaginaTodos(noPagina);
      }
    },
    getDataPaginaTodos(noPagina = 1) {
      if (this.cargaSeleccionada !== null) {
        let url;
        // Apply filters if they exist
        if (this.especialidadSeleccionada) {
          url = `/vwplanillas/tramite-especialidad/${this.p_tramite.idTramite}/${this.especialidadSeleccionada}`;
        } else if (this.numeroBusqueda) {
          url = `/vwplanillas/numero/${this.p_tramite.idTramite}/${this.numeroBusqueda}`;
        } else if (this.cedulaBusqueda) {
          url = `/vwplanillas/cedula/${this.p_tramite.idTramite}/${this.cedulaBusqueda}`;
        } else if (this.nombreBusqueda) {
          url = `/vwplanillas/nombre/${this.p_tramite.idTramite}/${this.nombreBusqueda}`;
        } else if (this.estadoAMBusqueda) {
          url = `/vwplanillas/estadoaud/${this.p_tramite.idTramite}/${this.estadoAMBusqueda}`;
        } else if (this.estadoGDBusqueda) {
          url = `/vwplanillas/estadodoc/${this.p_tramite.idTramite}/${this.estadoGDBusqueda}`;
        } else if (this.nivelBusqueda) {
          url = `/vwplanillas/idtramite-idcarga-nivel/${this.p_tramite.idTramite}/${this.cargaSeleccionada}/${this.nivelBusqueda}`;
        } else if (this.fechaAtencion) {
          url = `/vwplanillas/fecha/${this.p_tramite.idTramite}/${this.fechaAtencion}`;
        } else if (this.nombreMedico) {
          url = `/vwplanillas/nombre-medico/${this.p_tramite.idTramite}/${this.nombreMedico}`;
        } else {
          if (
            this.idPerfil == 15 ||
            this.idPerfil == 16 ||
            this.idPerfil == 17 ||
            this.idPerfil == 19 ||
            this.p_tramite.tipoAsignacion == "T"
          ) {
            url = `/vwplanillas/idtramite-idcarga-order-nombre/${this.p_tramite.idTramite}/${this.cargaSeleccionada}`;
/*			
          } else if (this.idPerfil == 18) {
            url = `/vwplanillas/tramite-usuario/${this.p_tramite.idTramite}/med/${this.idUsuario}`;
          } else if (this.idPerfil == 20) {
            url = `/vwplanillas/tramite-usuario/${this.p_tramite.idTramite}/doc/${this.idUsuario}`;
*/			
          }
        }
        this.fetchData(url, true, noPagina);
      }
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas) {
        this.paginaActual++;
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    irPrimeraPagina() {
      if (this.paginaActual !== 1) {
        this.paginaActual = 1;
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    irUltimaPagina() {
      if (this.paginaActual !== this.totalPaginas) {
        this.paginaActual = this.totalPaginas;
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "cedula",
        "nombre",
        "diag1",
        "diag2",
        "diag3",
        "diag4",
        "diag5",
        "fechaDesde",
        "fechaHasta",
        "horaDesde",
        "horaHasta",
        "estadoAud",
      ];
      return validarForm(this.datoPlanilla, requiredFields, requiredFields);
    },
    abrirModalEditar(idPlanilla) {
      if (!idPlanilla) return;
      this.modalWindow = true;
      api.get(`/vwplanillas/${idPlanilla}`)
        .then((resp) => {
          this.datoPlanilla = resp.data || {};
          this.titulo = "Resumen de la atención médica";
          this.btnCrear = false;
          this.btnEditar = true;
          if (this.modalInstance) {
            this.modalInstance.show();
          }
        })
        .catch((error) => {
          console.error("Error al cargar la planilla:", error);
          this.$emit('error', 'No se pudo cargar la información de la planilla.');
        });
    },
    abrirEditar(idPlanilla) {
      if (idPlanilla) {
        this.$router.push(
          `/planillaform/${this.p_tramite.idTramite}/${this.p_tramite.estadoTramite}/${idPlanilla}`
        );
      }
    },
    async deletePlanilla(idPlanilla) {
      try {
        await api.delete(`/planillas/${idPlanilla}`);
        this.getDataPaginaTodos(this.paginaActual);
        this.$emit('success', 'Planilla eliminada correctamente.');
      } catch (error) {
        console.error("Error al eliminar la planilla:", error);
        this.$emit('error', 'No se pudo eliminar la planilla.');
      }
    },
    async getEspecialidades() {
      try {
        const response = await api.get("/vwespecialidads");
        this.especialidades = response.data || [];
      } catch (error) {
        console.error("Error al obtener especialidades:", error);
        this.$emit('error', 'No se pudieron cargar las especialidades.');
      }
    },
    abrirPlanillaPDF(p_idPlanilla) {
      if (!p_idPlanilla) return;
      const url = `${config.apiBaseUrl}/reportes/pdf/9/${p_idPlanilla}`;
      window.open(url, "_blank");
    },
    async fetchCargas() {
      try {
        const response = await api.get(`/vwcargas/activas-por-tramite/${this.p_tramite.idTramite}`);
        this.cargas = response.data || [];
      } catch (error) {
        console.error("Error al obtener cargas:", error);
        this.$emit('error', 'No se pudieron cargar las cargas.');
      }
    },
    formatFecha(fecha) {
      return fecha ? fecha.split("T")[0] : "";
    },
    handleSelection() {
      this.getDataCarga(1);
    },
    async updateNivel(idPlanilla, nivel) {
      try {
        await api.put(`/planillas/actualizar-nivel/${idPlanilla}?nivel=${nivel}`);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        console.error(`Error al actualizar nivel:`, error);
        this.$emit('error', `No se pudo actualizar el nivel.`);
      }
    },
    async toggleAllNiveles(nivel) {
      try {
        if (!this.cargaSeleccionada) {
          Swal.fire({
            icon: 'warning',
            title: 'Seleccione la semana/carga',
            confirmButtonText: 'OK'
          });
          return; // No ejecuta nada más si no hay carga
        }
        await api.put(`/planillas/actualizar-nivel-carga/${this.cargaSeleccionada}?nivel=${nivel}`);
        this.getDataPaginaTodos(this.paginaActual);
        this.$emit('success', `Todos los niveles actualizados correctamente a ${nivel}.`);
      } catch (error) {
        console.error(`Error al actualizar todos los niveles a ${nivel}:`, error);
        this.$emit('error', `No se pudo actualizar todos los niveles a ${nivel}.`);
      }
    },
    exportarCSV() {
      if (this.planillas.length === 0) {
        this.$emit('error', 'No hay datos para exportar.');
        return;
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "ID Planilla;Número;Fecha de atención;Cédula;Nombre;Cédula médico;Nivel\n";
      this.planillas.forEach((planilla) => {
        csvContent += `${planilla.idPlanilla};${planilla.numero};${this.formatFecha(planilla.fechaDesde)};${planilla.cedula};${planilla.nombre};${planilla.cedulaMedico};${planilla.nivel || 'N/A'}\n`;
      });
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `Atenciones_tramite_${this.p_tramite.idTramite}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    cargarSemanasDelMes() {
      api.get(`/vwsemanas/rango?desde=${this.p_tramite.fechaDesde}&hasta=${this.p_tramite.fechaHasta}`)
        .then((resp) => {
          this.semanas = resp.data || [];
        })
        .catch((error) => {
          console.error("Error al cargar semanas:", error);
          this.$emit('error', 'No se pudieron cargar las semanas.');
        });
    },
  },
};
</script>

<style scoped>
.table-hover tbody tr {
  cursor: pointer;
}
</style>